module.exports = __webpack_public_path__ + "img/yun2.f3ac22b8.png";